export default __webpack_public_path__ + "static/media/cladding29.7a43b0cb.jpg";